import { render } from "./GroupReportList.vue?vue&type=template&id=461fdecd"
import script from "./GroupReportList.vue?vue&type=script&lang=js"
export * from "./GroupReportList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__